<template>
  <div class="app-tags" :class="{ opaque }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppTags',

  props: {
    opaque: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem;

  &.opaque {
    > .app-tag {
      background-color: rgba(0, 0, 0, 0.25) !important;
      color: rgba(255, 255, 255, 0.85) !important;
    }
  }
}
</style>
